import React, { useCallback, useEffect, useRef, useState } from "react";
import ApiSession from "../../api/ApiSession";
import { getProjectId } from "../../utils/project";
import Snackbar from "../SE-Component/Snackbar";
import { withRouter } from "react-router-dom";
import { projectAtomList } from "../../atoms";
import { useAtom } from "jotai";
import { shellLayoutConst } from "../../utils/constants";
import useProjectTypeValue from "../../utils/useCurrentProjectValue";
const apiSession = new ApiSession();
const TimeSync = (props) => {
const { projectId: urlProject } = props?.match?.params;
// const [ip, setIp] = useState("192.168.127.254");
const [ip, setIp] = useState(null);
const projectTypeValue = useProjectTypeValue();
  const [redirectAlert, setRedirectAlert] = useState({
    message: "",
    alertPopUpStatus: false,
    title: "",
    isRoute: false,
    routePath: "",
  });
  const [timeServer, setTimeServer] = useState({
    primaryTimeServer: "",
    secondaryTimeServer: "",
  });
  let userSampleData = {
      name: "",
      role: "",
      access: {},
    };
  let userScope =
    JSON.parse(localStorage.getItem("scope")) !== null
      ? JSON.parse(localStorage.getItem("scope"))
      : userSampleData;
  const [UserScope] = useState(userScope);
  const timeSnackBarRef = useRef(null);
  const [snackBar, setSnackBar] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [currentProject, setCurrentProject] = useAtom(projectAtomList);
  const closeRedirectAlertPopup = useCallback(() => {
    setRedirectAlert({
      message: "",
      alertPopUpStatus: false,
      title: "",
      isRoute: false,
      routePath: "",
    });
    if (redirectAlert?.isRoute) {
      let { history } = props;
      props?.setKey("system");
      history.push({
        pathname: `${redirectAlert?.routePath}`,
      });
    }else if(props?.secureArchitectureData?.gatewayType === ""){
          props?.setKey("secure");
    }
  }, [redirectAlert, props]);
  const callSnackbar = useCallback((type, message) => {
    try {
      setSnackBar({ type, message });
      timeSnackBarRef.current.open = true;
    } catch (error) {
      console.log("error in snack bar");
    }
  }, []);
  const saveNTPTimeServer = async () => {
    let { history } = props || {};
    let jsonBody = {
      projectId: urlProject,
      primaryNTPTimeServer: timeServer.primaryTimeServer,
      secondaryNTPTimeServer: timeServer.secondaryTimeServer,
      timeSynchronizationServerIPAddress: null
      // timeSynchronizationServerIPAddress: ip === null || ip === undefined? "192.168.127.254":ip,
    };

    try {
      setLoading(true);
      let json = await apiSession.updateTimeServer(jsonBody);

      if (json) {
        setLoading(false);
        sessionStorage.setItem("timeSyncValidate", true);
        setTimeServer((prevState) => ({
          ...prevState,
          primaryNTPTimeServer: json?.primaryNTPTimeServer,
          secondaryNTPTimeServer: json?.secondaryNTPTimeServer,
        }));
        // setIp( json?.timeSynchronizationServerIPAddress);
        if (urlProject) {
          apiSession
            .getProject(urlProject)
            .then((json) => {
              if(json){
              if(json?.secureArchitecturePage !== true){
                document.getElementById("dialog-secure-validation").open = true;
                setCurrentProject((prevData) => ({
                ...prevData,
                showBOM:false,
                showDeploy:false,
              }));
               return;
              }else{
                 setCurrentProject((prevData) => ({
                ...prevData,
                project: json,
                timeSettingsValidated: json?.systemsTimeSyncPage,
                showAsset: json?.projectId,
                showUseCase: json?.deploymentReady,
                showSystems: !json?.programPage,
                showBOM:
                  json.systemsPage === false &&
                  json?.secureArchitecturePage === true &&
                  json.systemsTimeSyncPage === true &&
                  !json?.programPage,
                showDeploy:
                  json.systemsPage === false &&
                  json?.secureArchitecturePage === true &&
                  json.systemsTimeSyncPage === true &&
                  !json?.programPage,
              }));
              }
              
              sessionStorage.setItem("pType", json?.projectTypeDisplayValue);
              sessionStorage.setItem("pname", json?.projectTypeDisplayValue);
              sessionStorage.setItem("projectId", json?.projectId);
              sessionStorage.setItem("projectKindType", json?.projectType);
              sessionStorage.setItem("deploymentReady", json?.deploymentReady);
              sessionStorage.setItem(
                "projectType",
                JSON.stringify({ projectTypeValue: json?.projectType })
              );
              if (json?.systemsPage) {
                setRedirectAlert((prev) => ({
                  message: shellLayoutConst.VALIDATE_SYSTEMS_ALERT,
                  alertPopUpStatus: true,
                  title: "ALERT",
                  isRoute: true,
                  routePath: `/systems/${urlProject}`,
                }));
              } else {
                // Navigate after project data is fetched and state is updated
                const isSystemPageValidated = json.systemsPage === false;
                const isSecureArchitectureValidated = json?.secureArchitecturePage === true;
                const isTimeSyncValidated = json?.systemsTimeSyncPage === true;
                if (isSystemPageValidated && isSecureArchitectureValidated && isTimeSyncValidated && !json?.programPage) {
                  history.push({
                    pathname: `/bom/${urlProject}`,
                  });
                }
              }
            }
            })
            .catch((error) => {
              if (error?.status === 404) {
                setRedirectAlert((prev) => ({
                  message: shellLayoutConst.VALIDATE_SYSTEMS_ALERT,
                  alertPopUpStatus: true,
                  title: "ALERT",
                  isRoute: true,
                  routePath: `/systems`,
                }));
              }
            });
        }

        if (props && typeof props.setTimeSyncData === "function") {
          props.setTimeSyncData(json);
        }
        const timeSyncDialog = document.getElementById("dialog-timeSync-status");
        if (timeSyncDialog) timeSyncDialog.open = false;
        callSnackbar("success", "Time Server Updated Successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleNTPTimeServer = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setTimeServer((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const getTimeServer = () => {
    try {
      apiSession
        .getTimeServer(urlProject)
        .then((response) => {
          if (response) {
            if (response.timeServerEntity === null) {
              sessionStorage.setItem("timeSyncValidate", false);
              setTimeServer((prevState) => ({
                ...prevState,
                primaryTimeServer:
                  response?.defaultNTPServerData?.primaryNTPTimeServer,
                secondaryTimeServer:
                  response?.defaultNTPServerData?.secondaryNTPTimeServer,
              }));
            //  setIp( response?.defaultNTPServerData?.timeSynchronizationserverIPAddress); 
              props?.setTimeSyncData(response);
            } else {
              sessionStorage.setItem("timeSyncValidate", true);
              setTimeServer((prevState) => ({
                ...prevState,
                primaryTimeServer:
                  response?.timeServerEntity?.primaryNTPTimeServer,
                secondaryTimeServer:
                  response?.timeServerEntity?.secondaryNTPTimeServer,
              }));
              // setIp( response?.timeServerEntity?.timeSynchronizationserverIPAddress) 
            }
          }
        })
        .catch((error) => {
          if (error.response !== undefined) {
            if (error.response.status === 412) {
              console.log(error);
            }
          }
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (props?.siteType !== "GENSET_PVBESS_A2E" && props?.siteType !== "") {
      getTimeServer();
    }
  }, [props?.siteType]);

  const formatIp = (value) => {
    const digits = value.replace(/\D/g, "");
    const segments = [];
    if (digits.length > 0) segments.push(digits.substring(0, 3));
    if (digits.length > 3) segments.push(digits.substring(3, 6));
    if (digits.length > 6) segments.push(digits.substring(6, 9));
    if (digits.length > 9) segments.push(digits.substring(9, 12));
    return segments.join(".");
  };
  const handleChange = (e) => {
    const raw = e.target.value;
    const formatted = formatIp(raw);
    // setIp(formatted);
    // setIp(null);
  };
const onButtonClickValidated = () => {
  document.getElementById("dialog-secure-validation").open = false;
  props?.setKey("secure");
}
  return (
    <>
      <se-dialog
        id="AlertDialog"
        open={redirectAlert.alertPopUpStatus}
        can-backdrop="false"
      >
        <se-dialog-header>{redirectAlert.title}</se-dialog-header>
        <se-dialog-content
          icon="information_circle"
          color="primary"
          className="se-header-font-size-16px se-life-green"
        >
          {redirectAlert.message}
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeRedirectAlertPopup}>OK</se-button>
        </se-dialog-footer>
      </se-dialog>
      <se-loading loading={loading} full-page="true"></se-loading>
      <div
        className={
         ( props?.siteCreated && projectTypeValue !== "NMGaaS ETO") ||
          !UserScope.access.saveSystemInfo ||
          props?.projectStatusData?.projectStatus === "COMPLETED" ||
          props?.projectStatusData?.projectStatus === "COMPLETED_AND_SEND"
            ? "se-block-disabled row"
            : "row"
        }
      >
        <div className="col-md-12">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ml-2">
              <span className="ml-2 se-font-14px-bold se-life-green">
                Time Server Settings
              </span>
              <div className="dropdown-divider"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 se-white-background mt-2 ml-2">
              <div className="form-group row mb-2">
                <label
                  htmlFor="primaryNTP"
                  className="col-sm-3 col-form-label col-form-label-sm se-font-14px mt-2 text-right"
                >
                  <span className="se-font-14px-bold">
                    Primary NTP Time Server{" "}
                  </span>
                  {/* <span className="se-mandatory">*</span> */}
                </label>
                <div className="col-sm-4 mt-2">
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-sm"
                    name="primaryTimeServer"
                    placeholder="Primary NTP Time Server"
                    maxLength="50"
                    value={timeServer?.primaryTimeServer}
                    onChange={handleNTPTimeServer}
                  />
                  {/* {primaryNTP === "" && (
                <div className="invalid-feedback-custom">
                  Primary NTP Time Server is required.
                </div>
              )} */}
                </div>
              </div>
              <div className="form-group row mb-2">
                <label
                  htmlFor="secondaryNTP"
                  className="col-sm-3 col-form-label col-form-label-sm se-font-14px mt-2 text-right"
                >
                  <span className="se-font-14px-bold">
                    Secondary NTP Time Server{" "}
                  </span>
                  {/* <span className="se-mandatory">*</span> */}
                </label>
                <div className="col-sm-4 mt-2">
                  <input
                    type="text"
                    autoComplete="none"
                    className="form-control form-control-sm"
                    name="secondaryTimeServer"
                    placeholder="Secondary NTP Time Server"
                    maxLength="50"
                    value={timeServer?.secondaryTimeServer}
                    onChange={handleNTPTimeServer}
                  />
                  {/* {primaryNTP === "" && (
                <div className="invalid-feedback-custom">
                  Primary NTP Time Server is required.
                </div>
              )} */}
                </div>
              </div>
              {/* Adding false to disable default update of time synchronization server IP address field */}
            { false && ["DaaS ETO", "MGaaS ETO", "NMGaaS ETO"].includes(props?.projectTypeValue) && <div className="form-group row mb-2">
                <label
                  htmlFor="timeSynchronizationServerIPAddress"
                  className="col-sm-3 col-form-label col-form-label-sm se-font-14px mt-2 text-right"
                >
                  <span className="se-font-14px-bold">
                    Time Synchronization server IP Address{" "}
                  </span>
                  <span className="se-mandatory">*</span>
                </label>
                <div className="col-sm-4 mt-2">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="timeSynchronizationServerIPAddress"
                    value={ip}
                    onChange={handleChange}
                    maxLength="15"
                    placeholder="xxx.xxx.xxx.xxx"
                    autoComplete="off"
                  />
               {  ip?.length < 15 && <div className="invalid-feedback-custom">Invalid IP Address.</div>}
                </div>
                
              </div>}
              <div className=" form-group row mb-2 text-right">
                <div className="col-sm-7 p-0">
                  <se-button
                    option="flat"
                    color="primary"
                    padding="large"
                    onClick={saveNTPTimeServer}
                    disabled={["DaaS ETO", "MGaaS ETO", "NMGaaS ETO"].includes(props?.projectTypeValue) ? ip?.length < 15?true:false : false}
                  >
                    Save
                  </se-button>
                </div>
              </div>
            </div>
          </div>
          <se-dialog
                id="dialog-secure-validation"
                can-backdrop="false"
                size="small"
              >
                <se-dialog-header>
                  Secure Architecture validation status
                </se-dialog-header>
                <se-dialog-content icon="information_circle" size="nano">
                  Secure Architecture is validated
                </se-dialog-content>
                <se-dialog-footer>
                  <se-button onClick={onButtonClickValidated}>OK</se-button>
                </se-dialog-footer>
              </se-dialog>
          <Snackbar snackBar={snackBar} ref={timeSnackBarRef} />
        </div>
      </div>
    </>
  );
};

export default withRouter(TimeSync);
